module.exports = __webpack_public_path__ + "images/category_lp/musical_instrument/new/store_images/3_34974a2c32d5b835acdba10ef41df328.png";